import React from 'react';
import pythonlogo from './imgs/skills/pythonlogo.svg';
import reactlogo from './imgs/skills/reactlogo.svg';
import flasklogoskills from './imgs/skills/flasklogo.svg';
import tensorflowlogo from './imgs/skills/tensorflowlogo.svg';
import herokulogo from './imgs/skills/herokulogo.svg';
import azurelogo from './imgs/skills/azurelogo.svg';
import linuxlogo from './imgs/skills/linuxlogo.svg';
import seleniumlogo from './imgs/skills/seleniumlogo.svg';
import mongodblogo from './imgs/skills/mongodblogo.svg';
import html5logo from './imgs/skills/html5logo.svg';
import csslogo from './imgs/skills/csslogo.svg';
import gitlogo from './imgs/skills/gitlogo.svg';
import typelogo from './imgs/skills/typescriptlogo.svg';
import dockerlogo from './imgs/skills/dockerlogo.svg';
import javscriptlogo from './imgs/skills/javascriptlogo.svg';

const skillsList = [
  { logo: pythonlogo, name: "Python" },
  { logo: reactlogo, name: "React" },
  { logo: html5logo, name: "HTML5" },
  { logo: csslogo, name: "CSS3" },
  { logo: javscriptlogo, name: "JavaScript" },
  { logo: flasklogoskills, name: "Flask" },
  { logo: mongodblogo, name: "MongoDB" },
  { logo: tensorflowlogo, name: "TensorFlow" },
  { logo: herokulogo, name: "Heroku" },
  { logo: azurelogo, name: "Azure", isWide: true },
  { logo: gitlogo, name: "Git" },
  { logo: seleniumlogo, name: "Selenium" },
  { logo: linuxlogo, name: "Linux" },
  { logo: typelogo, name: "TypeScript" },
  { logo: dockerlogo, name: "Docker" }
];

function Skills() {
  return (
    <div className="portfolio-section-light">
      <h2 id="skills" className="portfolio-section-title">
        <span style={{ color: "var(--color-accent)" }}>My</span> Skills
      </h2>
      <div className="skills-container">
        <div className="skills-grid">
          {skillsList.map((skill) => (
            <div 
              className={`skill-item ${skill.isWide ? 'skill-item-wide' : ''}`} 
              key={skill.name}
            >
              <img src={skill.logo} className="skill-icon-img" alt={`${skill.name} Logo`} />
              <div style={{ marginTop: '0.5rem', fontWeight: '600', fontSize: '0.95rem', color: '#1e1e1e' }}>
                {skill.name}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Skills;